/**
 * Container for Dropdown
 *
 * @module containers/Dropdown
 */

import React from 'react';
import { connect } from 'react-redux';

import { closeDropdown } from '../../actions/Dropdown';
import Dropdown from '../../components/Dropdown/Dropdown';
import { DROPDOWN_KEY } from '../../constants/Dropdown';

class DropdownContainer extends React.Component {
  render() {
    return <Dropdown {...this.props} />;
  }
}

export function mapStateToProps(state) {
  return {
    dropdowns: state.dropdown.get(DROPDOWN_KEY),
  };
}

export default connect(mapStateToProps, { closeDropdown })(DropdownContainer);
